/* Step 11d-3 · Mars Live Run Log V3 find 7 — the counter at the top of Head Folders read "Sign-offs: Preparer 3 / 41" before any
   head-folder sign-off: it showed the ENGAGEMENT roll-up (signoffs.rollup: every item — the Acceptance forms, planning, risk,
   sampling, completion …). It now adds up the head folders shown on the page only (the per-folder roll-ups the server already
   sends, rollup.folders[<fs code>]) and its label says so. The server's figures and the lock check are unchanged. */
import React from "react";
import SignoffRollup from "@/components/SignoffRollup";
import { asArray } from "@/lib/asArray";

/** {level: {signed, total}} summed over the given head-folder codes. */
export function headFoldersRollup(rollup, fsCodes, levels) {
  const folders = (rollup && rollup.folders) || {};
  const out = {};
  for (const lv of asArray(levels)) out[lv] = { signed: 0, total: 0 };
  for (const code of new Set(asArray(fsCodes))) {
    const c = folders[code];
    if (!c) continue;
    for (const lv of asArray(levels)) {
      out[lv].signed += Number((c[lv] || {}).signed || 0);
      out[lv].total += Number((c[lv] || {}).total || 0);
    }
  }
  return out;
}

export default function HeadFoldersSignoffTotal({ so, heads, t }) {
  if (!so) return null;
  const codes = asArray(heads).map((h) => h && h.fs_code).filter(Boolean);
  const counts = headFoldersRollup(so.rollup, codes, so.levels);
  return (
    <div className="mt-1 text-xs" title={t("s11d3.hfRollupTitle")} data-testid="hf-signoff-rollup-heads-line">
      {t("s11d3.hfRollup")}: <SignoffRollup counts={counts} levels={so.levels} t={t} testid="hf-signoff-rollup-heads" />
    </div>
  );
}
